<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/bankstatement")
          i.fa.fa-poll-h
          span.ml-1 {{ $t("ui.bank_statement") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.month") }}
                    //- b-form-select(:options="monthOpt" v-model="selectedMonth" @input="getBankStatement")
                    b-form-select(:options="monthOpt" v-model="selectedMonth")
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $tc("ui.banks", 1) }}
                    BankAccountList(
                      ref="bank"
                      size="sm"
                      required
                      type="array"
                      v-model="bank"
                      :disabled="loading"
                      filterBankAccStatus=false
                    )
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getBankStatement()"
                    variant="success"
                    size="sm"
                    ).mr-2
                  jsonToExcel(v-if="statementList.length > 0" mode="BankStatement" tbl="tblList" :date="dateRange")
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex#tblList(style="width: auto;min-width: 50%;")
                  thead
                    tr
                      th.sticky-position(width="8%")
                        span #
                      th.sticky-position.sortable(width="18%" @click="sortOrder('transfer_date', 'report')")
                        span(:title="$t('ui.transfer_date')") {{ $t('ui.transfer_date') }}
                        i(:class="changeSortKey('transfer_date', 'report')")
                      th.sticky-position(width="38%")
                        span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
                      th.sticky-position(width="18%")
                        span(:title="$t('ui.credit')") {{ $t('ui.credit') }}
                      th.sticky-position.sortable(width="18%")
                        span(:title="$t('ui.debit')") {{ $t('ui.debit') }}
                  tbody.clusterize-content
                    tr(v-if="statementList.length == 0")
                      td(:colspan="5").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in statementList")
                      td
                        span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="$moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      td
                        span.font-weight-bold {{ item.transfer_type }}

                        br(v-if="item.transfer_type == 'TRANSFER' && item.transfer_method")
                        span(v-if="item.transfer_type == 'TRANSFER' && item.transfer_method") {{ item.transfer_method }}
                        br(v-if="(item.transfer_type == 'TRANSFER' && item.bank_id)")
                        span(v-if="(item.transfer_type == 'TRANSFER' && item.bank_id)") {{ item.bank_id }}
                        br(v-if="(item.transfer_type == 'TRANSFER' && item.bank_acc_no)")
                        span(v-if="(item.transfer_type == 'TRANSFER' && item.bank_acc_no)") {{ item.bank_acc_no }}
                        br(v-if="(item.transfer_type == 'TRANSFER' && item.bank_acc_holder)")
                        span(v-if="(item.transfer_type == 'TRANSFER' && item.bank_acc_holder)") {{ item.bank_acc_holder }}

                        br(v-if="item.transfer_type == 'DEPOSIT' && item.transfer_method")
                        span(v-if="item.transfer_type == 'DEPOSIT' && item.transfer_method") {{ item.transfer_method }}
                        br(v-if="item.transfer_type == 'DEPOSIT' && item.account_id")
                        span(v-if="item.transfer_type == 'DEPOSIT' && item.account_id") {{ item.account_id }}

                        br(v-if="item.transfer_type == 'WITHDRAWAL' && item.transfer_method")
                        span(v-if="item.transfer_type == 'WITHDRAWAL' && item.transfer_method") {{ item.transfer_method }}
                        br(v-if="item.transfer_type == 'WITHDRAWAL' && item.account_id")
                        span(v-if="item.transfer_type == 'WITHDRAWAL' && item.account_id") {{ item.account_id }}

                        br(v-if="item.ref_no")
                        span.text-italic(v-if="item.ref_no") {{ item.ref_no }}
                        br(v-if="item.remark")
                        span.text-italic(v-if="item.remark") {{ item.remark }}
                      td
                        span.font-weight-bold(:title="$n(item.credit_amount, 'currency')") {{ $n(item.credit_amount, 'currency') }}
                      td
                        span.font-weight-bold.text-danger(:title="$n(item.debit_amount, 'currency')") {{ $n(item.debit_amount, 'currency') }}
                    tr(v-if="showTotal")
                      td.text-right(colspan="3")
                        span {{ $t("ui.sub_total") }}
                        br
                        span {{ $t("ui.grand_total") }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalCreditAmount)" :title="$n(subTotalCreditAmount, 'currency')") {{ $n(subTotalCreditAmount, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalCreditAmount)" :title="$n(grandTotalCreditAmount, 'currency')") {{ $n(grandTotalCreditAmount, 'currency') }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalDebitAmount)" :title="$n(subTotalDebitAmount, 'currency')") {{ $n(subTotalDebitAmount, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDebitAmount)" :title="$n(grandTotalDebitAmount, 'currency')") {{ $n(grandTotalDebitAmount, 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import BankAccountList from "@/library/BankAccountList";
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankAccountList,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    statementList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    subTotalDebitAmount: 0,
    grandTotalDebitAmount: 0,
    subTotalCreditAmount: 0,
    grandTotalCreditAmount: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    bank: '',
    monthOpt: [],
    selectedMonth: null,
    currentBank: null,
    sortKey: "transfer_date",
    sortType: "desc",
    dateRange: {
      startDate: null,
      endDate: null
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    // showExportBtn() {
    //   if (this.getAuthorityRole == 'SUB_PRI') {
    //     if (this.$store.getters.accountAuthority) {
    //       if (this.$store.getters.accountAuthority[0].authority_option.includes('export_excel'))
    //         return true;
    //       else
    //         return false;
    //     } else
    //       return false;
    //   } else {
    //     return true;
    //   }
    // }
  },
  mounted: function() {
    this.getDateOpt();
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getBankStatement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDateOpt() {
      for(var i = 0; i > -3; i--) {
        this.monthOpt.push(this.$moment(new Date).add(i, 'month').format('YYYY-MM'));
      }

      this.selectedMonth = this.$moment(new Date).format('YYYY-MM');
    },
    getBankStatement: function(isSearch) {
      this.currentBank = this.bank;

      let url = config.bankStatementUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        bank_id: this.bank == '' ? null : this.bank.split(' - ')[0].trim(),
        bank_acc_no: this.bank == '' ? null : this.bank.split(' - ')[1].trim(),
        working_month: this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD"),
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearTotal()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.dateRange.startDate = this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD");
                this.dateRange.endDate = this.$moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD");
                
                if(response.data.ds.statement.length > 0) {
                  this.showTotal = true;
                  response.data.ds.statement.forEach(value => {
                    this.subTotalDebitAmount = parseFloat(this.subTotalDebitAmount) + parseFloat(value["debit_amount"]);
                    this.subTotalCreditAmount = parseFloat(this.subTotalCreditAmount) + parseFloat(value["credit_amount"]);
                  });

                  if(response.data.ds.grand_total.length > 0) {
                    this.grandTotalDebitAmount = response.data.ds.grand_total[0]["debit_amount"];
                    this.grandTotalCreditAmount = response.data.ds.grand_total[0]["credit_amount"];
                  }

                  this.statementList = response.data.ds.statement;
                  this.totalRow = response.data.ds.statement.length > 0 ? this.statementList[0]["totalrows"] : 0
                } else {
                  this.clearTotal()
                }
              } else {
                this.clearTotal()
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.showTotal = false
      this.statementList = []
      this.totalRow = 0
      this.subTotalDebitAmount = 0
      this.grandTotalDebitAmount = 0
      this.subTotalCreditAmount = 0
      this.grandTotalCreditAmount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getBankStatement(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getBankStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>